import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_BATCH_11_CATEGORY_FAQS_250708 } from "@faire/retailer-settings/FE_BATCH_11_CATEGORY_FAQS_250708";

export const useSettingFeBatch11CategoryFaqs = (): boolean =>
  useSetting(FE_BATCH_11_CATEGORY_FAQS_250708);

export const useAssignSettingFeBatch11CategoryFaqs = () =>
  useAssignSetting(FE_BATCH_11_CATEGORY_FAQS_250708);
